var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zyc-note"},[_c('div',{staticClass:"zyc-note-t-l"}),_vm._v(" "),_c('div',{staticClass:"zyc-note-t-r"}),_vm._v(" "),_c('div',{staticClass:"zyc-note-b-l"}),_vm._v(" "),_c('div',{staticClass:"zyc-note-b-r"}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ad4bdc6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/zyc/container/noteContainer.vue
// module id = null
// module chunks = 